import { type FC } from "react";
import { type ShopAccordionProps } from "../ShopAccordion";
import * as styles from "./styles.css";

export const Shop: FC<ShopAccordionProps> = ({ shopInformations, gaAction, gaLabels, query }) => (
  <ul>
    {shopInformations.map(({ detailUrlWithShopId, name, address, nearestStation }, index) => (
      <li key={detailUrlWithShopId} className={styles.mainTableList}>
        <span>
          <a
            href={detailUrlWithShopId}
            className="js-add-query-strings ga-click"
            data-ga-action={gaAction}
            data-ga-label={gaLabels[index]}
            data-query-str={query}
          >
            {name}
          </a>
        </span>
        <span>
          {address} {nearestStation && `(${nearestStation})`}
        </span>
      </li>
    ))}
  </ul>
);
